<template>
    <modal-base lead-state="answered">
        <template #subtitle>Initiating call to your attorney...</template>
    </modal-base>
</template>

<script>
    export default {
        mounted() {
            // this.$store.commit('card', 'contact');
        }
    }
</script>
